/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Default timer configurations for tournament operations
 * @export
 * @interface TournamentTimerConfig
 */
export interface TournamentTimerConfig {
    /**
     * Default check-in window before match start
     * @type {number}
     * @memberof TournamentTimerConfig
     */
    checkInWindowMinutes?: number;
    /**
     * Minutes past scheduledTime before the deadline sweeper nudges both captains about an unstarted match
     * @type {number}
     * @memberof TournamentTimerConfig
     */
    noShowWindowMinutes?: number;
    /**
     * Minutes past scheduledTime before an unstarted match is flagged for admin attention
     * @type {number}
     * @memberof TournamentTimerConfig
     */
    noShowEscalateMinutes?: number;
    /**
     * Minutes after a match starts that captains may still submit a score. Single matches only — a series reports game by game. 0 disables.
     * @type {number}
     * @memberof TournamentTimerConfig
     */
    scoreSubmissionWindowMinutes?: number;
    /**
     * Minutes after the standing score was submitted that a captain may still dispute it. Applies on top of the structural gate (disputes also close once the next round starts). 0 disables.
     * @type {number}
     * @memberof TournamentTimerConfig
     */
    disputeWindowMinutes?: number;
    /**
     * Minutes an unanswered game-verified (telemetry pre-fill) score waits before auto-confirming
     * @type {number}
     * @memberof TournamentTimerConfig
     */
    verifiedScoreConfirmMinutes?: number;
    /**
     * Minutes an unanswered manual captain claim waits before auto-confirming
     * @type {number}
     * @memberof TournamentTimerConfig
     */
    manualScoreConfirmMinutes?: number;
    /**
     * Minimum minutes after a match starts before scores may be submitted. 0 disables the gate. Match End telemetry opens scoring immediately regardless.
     * @type {number}
     * @memberof TournamentTimerConfig
     */
    minMatchMinutesBeforeScoring?: number;
    /**
     * Minutes past scheduledTime a team has to ready up before the sweeper forfeits the match to the opponent who did ready. 0 disables the auto-forfeit.
     * @type {number}
     * @memberof TournamentTimerConfig
     */
    readyUpGraceMinutes?: number;
}

/**
 * Check if a given object implements the TournamentTimerConfig interface.
 */
export function instanceOfTournamentTimerConfig(value: object): value is TournamentTimerConfig {
    return true;
}

export function TournamentTimerConfigFromJSON(json: any): TournamentTimerConfig {
    return TournamentTimerConfigFromJSONTyped(json, false);
}

export function TournamentTimerConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentTimerConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'checkInWindowMinutes': json['checkInWindowMinutes'] == null ? undefined : json['checkInWindowMinutes'],
        'noShowWindowMinutes': json['noShowWindowMinutes'] == null ? undefined : json['noShowWindowMinutes'],
        'noShowEscalateMinutes': json['noShowEscalateMinutes'] == null ? undefined : json['noShowEscalateMinutes'],
        'scoreSubmissionWindowMinutes': json['scoreSubmissionWindowMinutes'] == null ? undefined : json['scoreSubmissionWindowMinutes'],
        'disputeWindowMinutes': json['disputeWindowMinutes'] == null ? undefined : json['disputeWindowMinutes'],
        'verifiedScoreConfirmMinutes': json['verifiedScoreConfirmMinutes'] == null ? undefined : json['verifiedScoreConfirmMinutes'],
        'manualScoreConfirmMinutes': json['manualScoreConfirmMinutes'] == null ? undefined : json['manualScoreConfirmMinutes'],
        'minMatchMinutesBeforeScoring': json['minMatchMinutesBeforeScoring'] == null ? undefined : json['minMatchMinutesBeforeScoring'],
        'readyUpGraceMinutes': json['readyUpGraceMinutes'] == null ? undefined : json['readyUpGraceMinutes'],
    };
}

export function TournamentTimerConfigToJSON(json: any): TournamentTimerConfig {
    return TournamentTimerConfigToJSONTyped(json, false);
}

export function TournamentTimerConfigToJSONTyped(value?: TournamentTimerConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkInWindowMinutes': value['checkInWindowMinutes'],
        'noShowWindowMinutes': value['noShowWindowMinutes'],
        'noShowEscalateMinutes': value['noShowEscalateMinutes'],
        'scoreSubmissionWindowMinutes': value['scoreSubmissionWindowMinutes'],
        'disputeWindowMinutes': value['disputeWindowMinutes'],
        'verifiedScoreConfirmMinutes': value['verifiedScoreConfirmMinutes'],
        'manualScoreConfirmMinutes': value['manualScoreConfirmMinutes'],
        'minMatchMinutesBeforeScoring': value['minMatchMinutesBeforeScoring'],
        'readyUpGraceMinutes': value['readyUpGraceMinutes'],
    };
}

